// The spotter truck this device runs yard checks from, kept in localStorage so
// it survives tab and app restarts. Saving a new one overwrites the old.

export interface StoredSpotterTruck {
  uuid: string;
  name: string;
  ziggy_uuid: string | null;
  account_id: string;
}

const SPOTTER_TRUCK_STORAGE_KEY = 'yardCheckSpotterTruck';

export const saveSpotterTruck = (truck: StoredSpotterTruck): void => {
  try {
    localStorage.setItem(SPOTTER_TRUCK_STORAGE_KEY, JSON.stringify(truck));
  } catch (error) {
    console.error('Failed to save spotter truck to localStorage:', error);
  }
};

// The saved truck, or null when there is none or it belongs to another account.
export const loadSpotterTruck = (accountId: string): StoredSpotterTruck | null => {
  try {
    const stored = localStorage.getItem(SPOTTER_TRUCK_STORAGE_KEY);
    if (!stored) return null;

    const truck = JSON.parse(stored) as StoredSpotterTruck;
    if (!truck?.uuid || !truck?.name) return null;
    return String(truck.account_id) === String(accountId) ? truck : null;
  } catch (error) {
    console.error('Failed to load spotter truck from localStorage:', error);
    return null;
  }
};
